import { Link } from 'react-router-dom';
import { Mail, MapPin, Twitter, Linkedin, Github } from 'lucide-react';

const FOOTER_LINKS = {
    Product: [
        { label: 'Features', path: '/features' },
        { label: 'Pricing', path: '/pricing' },
        { label: 'Industries', path: '/industries' },
        { label: 'Integrations', path: '/features#integrations' },
    ],
    Resources: [
        { label: 'Documentation', path: '#' },
        { label: 'API Reference', path: '#' },
        { label: 'Status', path: '#' },
        { label: 'Changelog', path: '#' },
    ],
    Company: [
        { label: 'About', path: '#' },
        { label: 'Privacy Policy', path: '#' },
        { label: 'Terms of Service', path: '#' },
        { label: 'Contact', path: '#' },
    ],
};

export default function Footer() {
    return (
        <footer
            style={{
                position: 'relative',
                borderTop: '1px solid rgba(255,255,255,0.06)',
                backgroundColor: 'rgba(12, 13, 32, 0.6)',
                padding: '4rem 0 2rem',
                marginTop: 'auto',
                overflow: 'hidden',
            }}
        >
            <div className="section-container relative z-10">
                <div
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5"
                    style={{ gap: '3rem' }}
                >
                    {/* Brand Column */}
                    <div style={{ gridColumn: 'span 2' }}>
                        <Link to="/" className="flex items-center" style={{ gap: '0.5rem', marginBottom: '1.25rem', textDecoration: 'none' }}>
                            <div
                                style={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: 8,
                                    background: 'linear-gradient(135deg, var(--color-nova), var(--color-plasma))',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
                                    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                                    <line x1="12" x2="12" y1="19" y2="22" />
                                </svg>
                            </div>
                            <span className="font-display font-bold text-starlight" style={{ fontSize: '1.125rem' }}>
                                Lumina Voice AI
                            </span>
                        </Link>
                        <p className="text-stardust" style={{ fontSize: '0.8125rem', opacity: 0.6, maxWidth: '280px', lineHeight: 1.6, marginBottom: '1.5rem' }}>
                            Autonomous voice agents that call, book, and convert —
                            so your team can focus on what matters.
                        </p>
                        <div className="flex items-center" style={{ gap: '0.75rem' }}>
                            {[
                                { icon: Twitter, label: 'Twitter' },
                                { icon: Linkedin, label: 'LinkedIn' },
                                { icon: Github, label: 'GitHub' },
                            ].map(({ icon: Icon, label }) => (
                                <a
                                    key={label}
                                    href="#"
                                    aria-label={label}
                                    style={{
                                        color: 'var(--color-stardust)',
                                        opacity: 0.4,
                                        transition: 'opacity 200ms, color 200ms',
                                    }}
                                >
                                    <Icon style={{ width: 16, height: 16 }} />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Link Columns */}
                    {Object.entries(FOOTER_LINKS).map(([heading, links]) => (
                        <div key={heading}>
                            <h4
                                className="font-display font-semibold text-starlight"
                                style={{ fontSize: '0.8125rem', marginBottom: '1rem', letterSpacing: '0.02em' }}
                            >
                                {heading}
                            </h4>
                            <ul style={{ display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
                                {links.map(({ label, path }) => (
                                    <li key={label}>
                                        <Link
                                            to={path}
                                            className="text-stardust"
                                            style={{
                                                fontSize: '0.8125rem',
                                                opacity: 0.5,
                                                textDecoration: 'none',
                                                transition: 'opacity 200ms',
                                            }}
                                        >
                                            {label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Bottom Bar */}
                <div
                    className="flex flex-col md:flex-row items-center justify-between"
                    style={{
                        marginTop: '3rem',
                        paddingTop: '2rem',
                        borderTop: '1px solid rgba(255,255,255,0.04)',
                        gap: '1rem',
                    }}
                >
                    <p className="text-stardust" style={{ fontSize: '0.7rem', opacity: 0.35 }}>
                        © {new Date().getFullYear()} Lumina Voice AI. All rights reserved.
                    </p>
                    <div className="flex items-center" style={{ gap: '1rem', fontSize: '0.7rem', color: 'var(--color-stardust)', opacity: 0.35 }}>
                        <span className="flex items-center" style={{ gap: '0.25rem' }}>
                            <Mail style={{ width: 12, height: 12 }} />
                            hello@luminavoiceai.com
                        </span>
                        <span className="flex items-center" style={{ gap: '0.25rem' }}>
                            <MapPin style={{ width: 12, height: 12 }} />
                            Calgary, Canada
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
